import { useEffect, useState } from 'react';
import { Reveal } from '@/components/motion';
import { public_api } from '@/lib/api';
import { Star, Quotes } from '@phosphor-icons/react';

export default function Testimonials() {
  const [items, setItems] = useState([]);
  useEffect(() => { public_api.testimonials().then(setItems).catch(() => setItems([])); }, []);
  return (
    <>
      <section className="pt-16 md:pt-24 pb-14" data-testid="testimonials-hero">
        <div className="container-x max-w-4xl">
          <Reveal>
            <div className="overline mb-6">Testimonials</div>
            <h1 className="h-display text-balance">"They just get it." — the compliment we hear most often.</h1>
            <p className="body-lg mt-8 max-w-2xl text-pretty">
              These are unedited words from real families, participants, support coordinators, aged care providers
              and hospital discharge teams across Australia.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="pb-24" data-testid="testimonials-grid">
        <div className="container-x grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {items.map((t, i) => (
            <Reveal key={t.id} delay={i * 0.05}>
              <div className="p-8 rounded-3xl bg-neutral-50 border border-neutral-200 h-full flex flex-col relative overflow-hidden">
                <Quotes size={40} weight="fill" className="text-brand/10 absolute -top-2 -left-2" />
                <div className="flex gap-0.5 mb-4">
                  {Array.from({ length: t.rating }).map((_, k) => (
                    <Star key={k} size={16} weight="fill" className="text-brand" />
                  ))}
                </div>
                <blockquote className="text-lg font-display text-ink leading-tight text-balance flex-1">
                  "{t.quote}"
                </blockquote>
                <div className="mt-6 pt-6 border-t border-neutral-200">
                  <div className="font-semibold text-ink">{t.author_name}</div>
                  <div className="text-sm text-ink-muted">{t.author_role}{t.author_location ? ` · ${t.author_location}` : ''}</div>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </section>
    </>
  );
}
